import useFetcher from "@/utils/use-fetcher";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";

interface ChangePasswordWithoutAuthRequest {
  tempToken: string;
  email: string;
  password: string;
}

interface ChangePasswordWithoutAuthResponse {
  message?: string;
}

export interface ChangePasswordWithoutAuthPathParameter {}

export const changePasswordWithoutAuthUrl = "/auth/change_password_with_token";
export const changePasswordWithoutAuthKey: YWRKey<ChangePasswordWithoutAuthPathParameter> =
  {
    url: (parameter) => {
      return calcUrl(changePasswordWithoutAuthUrl, parameter);
    },
    method: "put",
  };

export default function useChangePasswordWithoutAuth() {
  const fetcher = useFetcher<
    ChangePasswordWithoutAuthRequest,
    ChangePasswordWithoutAuthResponse
  >();

  return useYWR(changePasswordWithoutAuthKey, fetcher);
}
